import CollectionSearch from './CollectionSearch'
export default CollectionSearch
